import { useLocation } from "react-router-dom";

export const useApplicationId = (): string => {
  const { search } = useLocation();
  return new URLSearchParams(search).get("app_id") ?? "";
};
